import React, { VFC } from 'react';
import styled from 'styled-components';
import { useSettings } from '../../contexts/settingsContext';
import { theme } from '../../utils/theme';
import Typography from '../atoms/Typography';

interface Props {
  name: string;
  label?: string;
  borderColor?: string;
  disabled?: boolean;
  placeholder?: string;
  onChange: (
    e?:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLTextAreaElement>,
  ) => void;
  value: string;
  font?: string;
  radius?: string;
}

const StyledTextArea = styled.textarea<Props>`
  font-family: ${theme.font};
  resize: none;
  box-sizing: border-box;
  padding:8px;
  border-radius:${({ radius }) => radius};
  border:1px solid ${theme.colors.grey[40]};
  color: ${theme.colors.grey[100]};
  outline:none;
  font-family:${({ font }) => font};
  width:100%;
  :focus {
      border:1px solid ${({ borderColor }) =>
        borderColor || theme.colors.grey[100]};
      color: ${theme.colors.grey[100]};
      background-color: ${theme.colors.grey[20]};
  }
  :disabled{
    border:1px solid ${theme.colors.grey[20]};
    color: ${theme.colors.grey[20]};
  }
}
`;

const TextArea: VFC<Props> = ({
  onChange,
  label,
  borderColor,
  disabled,
  placeholder,
  ...props
}) => {
  const { fontFamily: font, cornerRadius: radius } = useSettings();

  return (
    <>
      {label && (
        <Typography
          translateKey={label}
          variant="input-label"
          disabled={disabled}
        />
      )}
      <StyledTextArea
        radius={radius}
        font={font}
        onChange={onChange}
        rows={6}
        placeholder={placeholder}
        disabled={disabled}
        borderColor={borderColor}
        {...props}
      />
    </>
  );
};

export default TextArea;
